module.exports = __webpack_public_path__ + "img/websafety_prod.0ee6e5ed.png";